import { Theme } from '@mui/material';
import styled from '@emotion/styled';

type ParamsStyle = {
    theme?: Theme;
}

export const ContentBody = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    flex-direction: column;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: 70%;
    }
`);

export const ContentNews = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    justify-content: flex-end;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: 30%;
    }
`);

export const BannerContent = styled.div(`
    width: 100%;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    margin-top: .8rem;

    img {
        width: 100%;
        height: auto;
        max-width: 100%;
        border-radius: 20px;
        background-size: cover;
    }

    button {
        width: 117px;
        height: 30px;
        font-size: .75rem;
        padding: 0;
        position: absolute;
    }
`);